import { ButtonHTMLAttributes } from "react";
import * as S from "./styles";

export type ChoiceProps = {
  title: string;
  size?: "medium" | "large";
  isSelected?: boolean;
} & ButtonHTMLAttributes<HTMLButtonElement>;

export function Choice({
  children,
  title,
  size,
  isSelected,
  ...props
}: ChoiceProps) {
  return (
    <S.Container size={size} isSelected={isSelected} {...props}>
      <h1>{title}</h1>

      {children}
    </S.Container>
  );
}
